var React = require('react');

function Cloud4 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.6807 42.5013C22.6807 42.5013 22.3694 32.5607 32.3689 28.212C42.3637 23.8633 51.7407 31.2407 51.7407 31.2407C51.7407 31.2407 45.7735 15.161 58.0957 6.07481C70.418 -3.01141 89.4018 -3.4002 99.09 15.3194C99.09 15.3194 109.861 -4.40819 133.576 10.6587C133.576 10.6587 150.472 22.7737 139.39 44.8341C139.39 44.8341 149.308 43.7445 152.641 50.7379C155.974 57.7266 153.494 70 141.636 70H15.0852C15.0852 70 1.13471 70.0768 0.052385 55.3219C-1.02994 40.567 14.932 37.4518 22.6807 42.5013Z","fill":"white"}));
}

Cloud4.defaultProps = {"width":"154","height":"70","viewBox":"0 0 154 70","fill":"none"};

module.exports = Cloud4;

Cloud4.default = Cloud4;
